







import { Component, Prop, Vue } from 'vue-property-decorator';

import { requestAction } from '@/api/resources/recurrence';

import FullTemplate from '@/shared/components/Template/Full.vue';
import Feedback from './components/Feedback.vue';
import Placeholder from './components/Placeholder.vue';

@Component({
  components: {
    FullTemplate,
    Feedback,
    Placeholder,
  },
})
export default class Recurrence extends Vue {
  @Prop() readonly contractId!: string;

  @Prop() readonly token!: string;

  @Prop() readonly actionType!: string;

  isLoading = false;

  hasError = false;

  get feedback() {
    if (this.hasError) {
      return {
        icon: 'warning',
        message: 'Caro assinante, infelizmente não conseguimos executar a sua solicitação. Por favor, entre em contato conosco pelo telefone (11) 4020-6712 ou pelo e-mail renovacoes@empiricus.com.br.',
      };
    }

    if (this.actionType === 'deactivate-recurrency') {
      return {
        icon: 'sentiment_dissatisfied',
        message: 'Caro assinante, inativamos a recorrência da sua assinatura com sucesso. Em caso de dúvida entre em contato com renovacoes@empiricus.com.br.',
      };
    }

    return {
      icon: 'sentiment_satisfied',
      message: 'Caro assinante, ativamos a recorrência da sua assinatura com sucesso. Em caso de dúvida entre em contato com renovacoes@empiricus.com.br.',
    };
  }

  async created() {
    this.isLoading = true;

    try {
      const response = await requestAction(this.contractId, this.actionType, this.token);

      if (response.data.status === 'failed') {
        this.hasError = true;
      }
    } catch {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }
}
